/** @format */

import { X } from "lucide-react";

export default function ModalVideo({
  isOpen,
  onClose,
  videoUrl,
}: {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="relative w-full max-w-4xl">
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 text-white hover:text-gray-300 transition">
          <X size={32} />
        </button>
        <div className="aspect-w-16 aspect-h-9 bg-black rounded-xl overflow-hidden"></div>
      </div>
    </div>
  );
}
